export default {
  data() {
    return {
      columns: [
        {
          prop: "id",
          label: "ID",
          default: "No ID"
        },
        {
          prop: "status",
          label: "status",
          default: "No status"
        },
        {
          prop: "note",
          label: "Order Notes"
        },
        {
          prop: "orderlines",
          label: "Order Details"
        },
        {
          prop: "user_id",
          label: "User ID"
        },
        {
          prop: "created_at",
          label: "Created at"
        },

        {
          prop: "action",
          label: "Action",
          isAction: true
        }
      ],
      paginationMeta: {
        current_page: 1,
        last_page: 1,
        total: 0,
        per_page: 15
      },
      propsToSearch: ["name"],
      searchQuery: ""
    };
  }
};
